import { render, staticRenderFns } from "./SalesorderRetrieved.vue?vue&type=template&id=321c5b8d&scoped=true"
import script from "./SalesorderRetrieved.vue?vue&type=script&lang=js"
export * from "./SalesorderRetrieved.vue?vue&type=script&lang=js"
import style0 from "./SalesorderRetrieved.vue?vue&type=style&index=0&id=321c5b8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321c5b8d",
  null
  
)

export default component.exports